import React from 'react';
import styles from './Avatar.module.scss';
import cx from 'classnames';
import Helper from '../../utils/Helper';
import { parseString } from '../../utils/stringHelper';
import Icon from '../Icon/Icon';
import { useTranslation } from 'react-i18next';

const Avatar = ({ alt = '', children, className, image, title, oneLetterAcronym = true, size = 'medium', onFocus }) => {
  const { t } = useTranslation();

  const getNameFirstLetter = username => {
    if (username) {
      const parsedName = parseString(username);
      return parsedName[0]?.toUpperCase();
    }
    return '';
  };

  return (
    <div
      className={cx(
        styles.container,
        styles[size],
        {
          [styles.labled]: !Boolean(image),
        },
        className
      )}
      tabIndex={0}
      aria-label={t('clip_organizer.add_modal.avatar')}
      onFocus={onFocus}
    >
      {image ? (
        <img className={styles.imageIcon} src={image} alt={alt} tabIndex={-1} />
      ) : title ? (
        <span tabIndex={-1} className={styles.titleContainer}>{oneLetterAcronym ? getNameFirstLetter(title) : Helper.generateShortName(title)}</span>
      ) : (
        <Icon src="avatar_placeholder" className={styles.placeholderIcon} />
      )}
      {children}
    </div>
  );
};

export default Avatar;
